<template>
	<div class="customer-footer">
		<div class="footer-top maxW" v-if="this.textArr.length" :class="{ 'hidden': isShowTop }">
			<div class="footer-text">
				<div class="footer-item" v-for="(item, index) in textArr" :key="index" :class="{ 'hidden': !item.content }">

					<template v-if="item.content">

						<i :class="item.icon" />
						<div class="label">{{ item.label }}</div>
						<span>：</span>
						<div class="content">{{ item.content }}</div>
					</template>
				</div>
			</div>
			<div v-if="0" class="footer-img" style="margin-right: 50px">
				<img src="../../../assets/images/v2/qrcode.png" />
				<p>公众号</p>
			</div>
			<div class="footer-img" v-if="info_pic">
				<img :src="`${BASE_URL}${info_pic}`" />
				<!-- <p>小程序</p> -->
			</div>
		</div>
		<div class="footer-top maxW" v-else>
			<div class="footer-text" v-if="textArr.length">
				<div class="footer-item" v-for="item in textArr.length" :key="item">
					<el-skeleton v-if="item.content" style="width:100%" :rows="1" :animated="true" />
				</div>

			</div>
		</div>

		<div class="footer-bottom maxW" v-if="info_copyright">
			{{ info_copyright }}
		</div>

		<!-- bottom骨架 -->
		<div class="footer-bottom maxW" v-else>
			<el-skeleton :rows="1" :animated="true" />
		</div>

	</div>
</template>
  
<script>
export default {
	data() {
		return {
			baseUrl: process.env.BASE_URL,
			textArr: [
				{
					icon: "el-icon-location-outline",
					label: this.$t("form.addr"),
					content: "",
				},
				{
					icon: "el-icon-office-building",
					label: this.$t("form.companyName"),
					content: "",
				},
				{
					icon: "el-icon-paperclip",
					label: this.$t("form.web"),
					content: "",
				},
			],
			info_copyright: "",
			info_pic: ''
		};
	},
	created() {
		this.getFooterInfo();
	},
	computed: {
		isShowTop() {
			let count = 0;
			this.textArr.forEach((element) => {
				if (element.content) {
					count = count + 1;
				}
			});
			return count === 0;
		},
	},
	methods: {
		getFooterInfo() {
			let success = (res) => {
				let info = res.data.info || {};
				this.info_copyright = info.info_copyright;
				this.info_pic = info.info_pic;
				this.textArr[0].content = info.info_address;
				this.textArr[1].content = info.info_name;
				this.textArr[2].content = info.info_web;
				this.$emit("emitInfoPhone", info.info_phone);
			};
			this.$ajax.get("/api/setting/page_foot", { func: { success } });
		},
	},
};
</script>
  
<style scoped lang='scss'>
.customer-footer {
	background-color: #2c2e3f;

	.footer-top {
		width: 100%;
		display: flex;
		padding: 1rem;
		border-bottom: #3f4150 dashed 1px;

		.footer-text {
			width: 100%;
		}

		.footer-img {
			width: 90px;
			height: 90px;
			margin-top: 10px;
			img {
				width: 75px;
				height: 75px;
			}
			p{
				color: #fff;
				text-align: center;
				padding-top:8px ;
			}
		}

		.footer-item {
			width: 100%;
			display: flex;
			font-size: 1rem;
			color: #fff;
			margin: 1.6rem 0;

			i {
				margin-right: 0.8rem;
			}

			.label {
				width: 6rem;
				text-align: justify;
				text-align-last: justify;
			}
		}
	}

	.hidden {
		display: none !important;
	}

	.footer-bottom {
		height: 4rem;
		line-height: 4rem;
		font-size: 1rem;
		color: #fff;
		text-align: center;
	}
}
</style>
  